export default "__VITE_ASSET__D7qJuKz6__"